var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.118 18.147c.488.475 1.28.475 1.768 0l6.248-6.072a1.193 1.193 0 0 0 0-1.72 1.277 1.277 0 0 0-1.769 0L11.25 14.36V2.715c0-.672-.558-1.215-1.249-1.215-.691 0-1.25.543-1.25 1.215v11.64L4.635 10.36a1.277 1.277 0 0 0-1.769 0 1.193 1.193 0 0 0 0 1.72l6.248 6.072.004-.004Z",
    fill: "#000"
  })));
};
export default SvgArrow;